module.exports = __webpack_public_path__ + "media/images/crypto-currencies/stellar-032edd5b2246c29cc4439b3ce6d7a7b6.svg";